import React, { useEffect } from 'react';
import './index.scss';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from '@roo/roo';
import { getSafeIframeSrc } from '../../utils/urlValidator';

const Root = styled.div`
  padding-bottom: 80px;
  width: 1200px;
  margin: auto;
  &.news-list {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #f4f4f4;
    .news-card {
      margin-bottom: 20px;
      width: 100%;
    }
  }
  &.article {
    margin-top: 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const Trend = () => {
  const p = new URLSearchParams(window.location.search);
  const [h, setH] = React.useState(0);
  const pageLink = decodeURIComponent(p.get('pageLink') || '');
  const safeSrc = getSafeIframeSrc(pageLink);

  useEffect(() => {
    /**
     * @param e{MessageEvent}
     */
    const handle = (e) => {
      setH(Number(e.data));
    };
    window.addEventListener('message', handle);
    return () => {
      window.removeEventListener('message', handle);
    };
  }, []);

  // 如果 URL 校验失败，显示错误信息
  if (!safeSrc) {
    return (
      <Root className="article">
        <div
          style={{
            marginTop: 40, padding: '20px', textAlign: 'center', color: '#999',
          }}
        >
          <p>无效的链接地址</p>
          <Link to="/trend">
            <Button>返回基金动态</Button>
          </Link>
        </div>
      </Root>
    );
  }

  return (
    <Root className="article">
      <iframe
        title="外部内容"
        src={safeSrc}
        frameBorder="0"
        style={{
          height: h, marginTop: 40, backgroundColor: '#f4f4f4', width: '100%',
        }}
      />
      <div style={{ marginTop: 40 }}>
        <Link to="/trend">
          <Button>返回基金动态</Button>
        </Link>
      </div>
    </Root>
  );
};

export default Trend;
